module.exports = __webpack_public_path__ + "5abd6d0065addfb807cc646fb400b02d.svg";